import R from "ramda";
import { requireNOfFields } from "src/components/Form/validation";

import { verificationFieldKeys } from "src/banking/authentication/sharedFields";

export const verficationFieldsValidator = (values, { t }) =>
  requireNOfFields(2, R.keys(verificationFieldKeys), values, t);



// WEBPACK FOOTER //
// ./src/banking/authentication/validation.js